<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="item-checkin mb-base overflow-hidden md:p-0 p-5" v-bind:style="bg_color" @click="onClickItem() ">
    <template slot="no-body">
      <div class="vx-row item-details no-gutter">
        <div class="vx-col md:w-1/6 sm:full xs:full flex flex-col justify-center">
          <div class="px-6">
            <slot name="item-meta">
              <h5 class="item-name font-bold mb-1 leading-loose">{{ item.name }}</h5>
              <span class="text-sm"><feather-icon icon="PhoneIcon" svgClasses="h-3 w-3" /> 0902791501</span>
              <p class="text-sm">
                <span>Check in: </span>
                <br/>
                <span class="text-primary">{{changeFormat(item.created_at)}}</span>
                <br />
                <span>Last reviewed: </span>
                <br/>
                <span class="text-primary">{{changeFormat(item.last_visited)}}</span>
              </p>
            </slot>
          </div>
        </div>

        <p class="item-description text-sm md:w-1/2 px-5 md:px-0 full m-auto">
          <span class="text-warning cursor-default mr-0">
            <span class="font-bold md:w-2/12 text-base ">Services</span>
            <span :key="index" v-for="(service, index) in item.services">
              <i class="p-1 bg-warning rounded text-white d-inline-block break-word text-center acronym-service-name">{{getAcronym(service.name)}}</i>
            </span>
            <i class="material-icons ml-auto cursor-pointer bg-warning text-white user-select-none edit-icon"
              v-on:click.stop="onClickService()"
            >create</i>
          </span>

          <vs-divider class="my-4"></vs-divider>

          <!-- <vx-tooltip text="Group">
                  <span class="text-success cursor-default">
                    <i class="material-icons">group</i>
                    <span :key="index" v-for="(group, index) in item.groups">
                      {{group.name}}
                    </span>
                  </span>
          </vx-tooltip>-->

          <span class="text-success cursor-default mr-0">
            <span class="font-bold md:w-2/12 text-base">Staff</span>
            <span :key="index" v-for="(staff, index) in item.staffs">
              <i class="p-1 bg-success rounded text-white d-inline-block break-word text-center acronym-staff-name">{{getAcronym(staff.name)}}</i>
            </span>
            <i class="material-icons ml-auto cursor-pointer bg-success text-white user-select-none edit-icon"
              v-on:click.stop="onClickStaff()"
            >create</i>
          </span>
        </p>

        <div class="vx-col md:w-1/6 w-full flex items-center sm:full">
          <div class="flex flex-col w-full">
            <div class="my-4 member-point rounded">
              <vs-alert :color="getMemberTypeColor(item.type)" class="text-center no-border-radius">
                {{item.type}}
              </vs-alert>
              <h5 class="font-bold text-center p-3">{{ item.point }} Pts</h5>
            </div>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div
          class="vx-col md:w-1/6 w-full flex items-center border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0 sm:full sm:border-l-0"
        >
          <div class="md:p-4 flex flex-col w-full">
            <div class="my-2">
              <h5 class="font-bold text-center">In Service</h5>
            </div>

            <!-- SLOT: ACTION BUTTONS -->
            <div class="flex justify-center">
              <!-- <slot name="action-buttons" /> -->
              <vs-switch v-model="temp" v-on:click.stop=""/>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
// import moment from 'moment';
export default {
  name: "item-checkin",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      staffs: [],
      services: [],
      bg_color: ''
    };
  },
  computed: {
    temp: {
      get() {
        if (this.item.status == "inservice") {
          // this.bg_color = "background: rgba(255, 255, 153, 0.18)"
          return true;
        }
        // this.bg_color = "background: #fff"
        return false;
      },
      set() {
        // this.$store.dispatch('eCommerce/updateInService', this.item.objectID)
      }
    },

  },
  methods: {
    changeFormat(day){
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    },
    onClickItem() {
      const checkin_info = {
        item_info: this.item
      }
      this.$emit('itemInfo', checkin_info)
    },

    onClickStaff() {
      const checkin_info = {
        staffs: this.item.staffs,
        checkin_name: this.item.name,
        checkin_at: this.item.created_at
      }
      this.$emit('editStaff', checkin_info)
    },

    onClickService() {
      const checkin_info = {
        services: this.item.services,
        checkin_name: this.item.name,
        checkin_at: this.item.created_at
      }
      this.$emit('editService', checkin_info)
    },

    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "regular") return "primary";
      if (member_type == "vip") return "danger";
      return "dark";
    },

    getAcronym(name) {
      let arr_word = name.split(' ');
      let str = '';
      for(let i = 0; i < arr_word.length; i++) {
        str += arr_word[i].charAt(0);
      }
      return str;
    }
  }
};
</script>
